module.exports = "datatable-header-cell {\r\n    font-size: 12px;\r\n}\r\n\r\ndatatable-body-cell {\r\n    font-size: 12px;\r\n}"